import { useState } from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { MdClose, MdSupportAgent } from "react-icons/md";
import "../styles/FloatingChat.css";

const WA_NUMBER = "919843222262";

const PHONE_NUMBERS = [
  {
    label: "Sales Team",
    number: "+91 98432 22262",
    link: "tel:+919843222262",
  },
  {
    label: "Support Team",
    number: "+91 98765 43210",
    link: "tel:+919876543210",
  },
];

export default function FloatingChat() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="kkb-chat-wrapper">
      {isOpen && (
        <div className="kkb-contact-options" id="kkb-contact-options">
          <a
            href={`https://wa.me/${WA_NUMBER}?text=Hi KKB Store, I'm interested in your products.`}
            target="_blank"
            rel="noreferrer"
            className="kkb-contact-option kkb-contact-whatsapp"
            onClick={() => setIsOpen(false)}
          >
            <FaWhatsapp aria-hidden="true" />
            <span>
              <strong>WhatsApp</strong>
              <small>Chat with our team</small>
            </span>
          </a>
          {PHONE_NUMBERS.map((phone) => (
            <a
              key={phone.label}
              href={phone.link}
              className="kkb-contact-option"
              onClick={() => setIsOpen(false)}
            >
              <FaPhoneAlt aria-hidden="true" />
              <span>
                <strong>{phone.label}</strong>
                <small>{phone.number}</small>
              </span>
            </a>
          ))}
        </div>
      )}
      <button
        className={`kkb-contact-toggle${isOpen ? " is-open" : ""}`}
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-label={isOpen ? "Close contact options" : "Contact us"}
        aria-expanded={isOpen}
        aria-controls={isOpen ? "kkb-contact-options" : undefined}
      >
        {isOpen ? <MdClose aria-hidden="true" /> : <MdSupportAgent aria-hidden="true" />}
        <span>{isOpen ? "Close" : "Contact us"}</span>
      </button>
    </div>
  );
}
